import { render } from "./Company_Details.vue?vue&type=template&id=3357943a"
import script from "./Company_Details.vue?vue&type=script&lang=js"
export * from "./Company_Details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__